import { api } from "../App";
import { SET_TYPES_OF_DOCUMENTS_LIST, SET_TYPES_OF_DOCUMENTS_BY_ID, SET_TYPES_OF_DOCUMENTS_LOADING } from "./types";


export const getTypesOfDocumentsList = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: true });
    const { data } = await api.get(`/documents_type`);
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: false });
  }
}
export const getTypesOfDocumentById = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: true });
    const { data } = await api.get(`/documents_type/${id}`);
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_BY_ID, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: false });
  }
}
export const createTypeOfDocument = (data, params) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: true });
    await api.post(`/documents_type`, data);
    await dispatch(getTypesOfDocumentsList(params))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: false });
    return success
  }
}
export const updateTypeOfDocument = ({ xp_key, ...data }) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: true });
    await api.put(`/documents_type/${xp_key}`, data);
    await dispatch(getTypesOfDocumentsList())
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: false });
    return success
  }
}

export const deleteTypeOfDocument = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: true });
    await api.delete(`/documents_type/${id}`);
    await dispatch(getTypesOfDocumentsList())
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TYPES_OF_DOCUMENTS_LOADING, payload: false });
  }
}